<template>
  <basic-container>
    <el-form :model="selectForm" ref="ruleForm" label-width="80px" >
         <el-row :gutter="24">
             
            <el-col :span="12">
                <el-form-item label="维修日期">
                     <el-date-picker
                                  style="width: 100%"
                                  clearable
                                  v-model="selectForm.timeRange"
                                  value-format="yyyy-MM-dd"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  >
                              </el-date-picker>
                </el-form-item>
            </el-col>
            
            <el-col :span="12">
                <div style="float:right">
                              <el-button type="primary" @click="searchRecord" icon="el-icon-search" size="small"> 搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete" size="small"> 清空 </el-button>
                </div>
            </el-col>

          
          </el-row>
    </el-form>
    <avue-crud
      :option="listOption"
      :table-loading="loading"
      :data="listData"
      v-model="selectForm"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
     <template slot="menuLeft">
         <el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord"> 新 增</el-button>
      </template>
       <template slot-scope="scope" slot="menu">
         <el-button
                type="text"
                size="small"
                icon="el-icon-tickets"
                @click="checkRecord(scope.row)"
                >查看
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="editRecord(scope.row)"
                >编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="removeRecord(scope.row.id)"
                >删除
            </el-button>
       </template>
    </avue-crud>

    
    <!-- <hr-dialog 
    :title="dialogTitle"
          v-if="addFlag"
          :visible.sync="addFlag"
         
          width="80%"
          :handleClose="handleClose"
    >
    <template slot="body">
      <addInspectRecord :row="row" :isAdd='true' :projectId="row.projectId"  :isEdit='true' :form='form' @cancelOperate="cancelOperate" @submitOver='submitOver'></addInspectRecord>
    </template>
    
    </hr-dialog>
    <hr-dialog
    :title="dialogTitle"
          v-if="watchFlag"
          :visible.sync="watchFlag"
          
          width="80%"
          :handleClose="handleClose"
    >
    <template slot="body">
      <addInspectRecord :isWatch='true' :projectId="row.projectId"  :isEdit='false' :form='form' @cancelOperate="cancelOperate" @submitOver='submitOver'></addInspectRecord>
    </template>
    
    </hr-dialog>
        <hr-dialog
        :title="dialogTitle"
          v-if="editFlag"
          :visible.sync="editFlag"
          
          width="80%"
          :handleClose="handleClose"
        >
        <template slot="body">
          <addInspectRecord :isWatch='true' :projectId="row.projectId"  :isEdit='true' :form='form' @cancelOperate="cancelOperate" @submitOver='submitOver'></addInspectRecord>
        </template>
         
        </hr-dialog> -->
      
        <addInspectionRecord2 
        v-if="addOrEditFlag"
        :dialogVisible.sync="addOrEditFlag" 
        :title="dialogTitle"
        :operatorModel='operatorModel' 
        :projectId="row.projectId"
         operatorObject='device'
         :deviceForm="form"
        :projectList='projectList'
        :row='deviceInspectRow'
        @successCallBack="successCallBack"
        ></addInspectionRecord2>
  </basic-container>
</template>

<script>
import {watchInspectRecordRecord,removeInspectRecord} from '@/api/crmedical/device/deviceInspectionStandard'
import { getProjectList } from '@/api/crmedical/project/project';
import {getInspectionList} from '@/api/crmedical/device/deviceInspectionStandard'
import addInspectRecord from "@/components/device/device/deviceInspectionRecord"
import addInspectionRecord2 from '@/components/device/deviceInspectionRecord/deviceInspect.vue';
  export default {
    props:["row"],
    components:{
      addInspectRecord,
      addInspectionRecord2
    },
    data() {
      return {
        deviceInspectRow:{},
        addOrEditFlag:false,
         operatorModel:'add',
        dialogTitle:'',
        editFlag:false,
        watchFlag:false,
        addFlag:false,
        form: {},
        selectForm: {
           timeRange:[]
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        listOption: {
          index: true,
        // selection: true,
        // reserveSelection:true,
        indexLabel: '序号',
        page: true,
        align: 'left',
        menuAlign: 'center',
        addBtn:false,
        editBtn: false,
        delBtn: false,
        border:true,
        height:'auto',
          column: [
            {
              label: "设备编号",
              prop: "code",
            },
            {
              label: "设备名称",
              prop: "deviceName",
              disabled: true,
              overHidden: true,
              span: 24,
            },
            {
              label: "巡检人",
              prop: "realInspectManName",
              overHidden: true,
            },
            {
              label: "巡检时间",
              prop: "realInspectTime",
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            // {
            //   label: "巡检时间",
            //   prop: "range",
            //   type:'daterange',
            //   hide: true,
            //   format: 'yyyy-MM-dd',
            //   valueFormat: 'yyyy-MM-dd',
            //   search: true,
            //   searchRange: true,
            //   searchSpan: 12,
            // },  
            {
               label: '巡检结果',
            prop: 'errorFlag',
             dicData: [{ name: '正常', errorFlag: 0 }, { name: '异常', errorFlag: 1 }],
            props: {
              value: 'errorFlag',
              label: 'name',
            },
            },
            {
            label:'工单编号',
            prop:'orderCode',
            width:'160',
            },
            {
              label: "备注",
              prop: "description",
             
            },
          ],
        },
        listData: [],
        projectList:[],
      };
    },
    created(){
      if(this.row.projectId){
        this.selectForm.projectId = this.row.projectId
        this.selectForm.deviceId = this.row.id
      }
      getProjectList().then((res) => {
        this.projectList = res.data;
       
      });
      
    },
    mounted(){
      this.listOption.height = this.bodyHeight - 379;
    },
    methods: {
      successCallBack(){
        this.onLoad()
      },
      cancelOperate(){
        this.handleClose()
      },
      submitOver(){
         this.handleClose()
         this.searchRecord()
      },
       searchRecord(){
           this.page.currentPage = 1
          if(this.selectForm.timeRange&&this.selectForm.timeRange.length>0){
                this.selectForm.startTime = this.dayjs(this.selectForm.timeRange[0]).format('YYYY-MM-DD 00:00:00')
                this.selectForm.endTime = this.dayjs(this.selectForm.timeRange[1]).format('YYYY-MM-DD 23:59:59') 
            }else{
                this.selectForm.timeRange = []
                this.selectForm.startTime = ''
                  this.selectForm.endTime = ''
            }
             this.onLoad()
        },
        searchClear(){
          this.$set(this.selectForm,'timeRange',[])
        },
       handleClose(){
        this.addFlag = false
        this.watchFlag = false
        this.editFlag = false
      },
      addRecord(){ 
        this.dialogTitle = "新增"
        this.form = this.row
        console.log('Shebeide ',this.form)
        this.form.orderCode = ''
        this.operatorModel = "add"
        this.addOrEditFlag = true
      },
      editRecord(row){
        this.dialogTitle = '编辑'
        this.operatorModel = "update"
        this.deviceInspectRow = row
        this.addOrEditFlag = true
        // watchInspectRecordRecord({id}).then(({data})=>{
        //   this.form = data
        //   this.editFlag = true
        // })
      },
       removeRecord(id){
       this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removeInspectRecord(id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.onLoad();
        });
      });
    },
      checkRecord(row){
        this.dialogTitle = '查看'
        
       
        this.operatorModel = "view"
        this.deviceInspectRow = row
        this.addOrEditFlag = true
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
     
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        console.log(this.query);
        getInspectionList(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, this.selectForm)).then(({data})=>{
                this.listData = data.records
                this.page.total = data.total
                this.loading = false;
            }).catch(()=>{
                this.loading = false;
            })
      }
    }
  };
</script>

<style>
</style>
